import React, { Suspense } from 'react';
import { IHeroLmpSlim } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchHeroSlim = React.lazy(() => import('./match-hero-slim'));
export interface IDynamicMatchHeroSlim extends IComponentModel<IHeroLmpSlim> {
  live?: boolean;
  model: any;
}

const DynamicHeroSlim: React.FC<IDynamicMatchHeroSlim> = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicMatchHeroSlim) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchHeroSlim initialModel={validateModel(model) as IHeroLmpSlim} query={validateModel(query)} live={live} />
  </Suspense>
);

DynamicHeroSlim.defaultProps = {
  live: false,
};

export default DynamicHeroSlim;
